import { post, get, put, patch, remove } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";

export const getDefaultNotificationPreference = async (project: any) => {
  try {
    const res = await get(`${ApiUrl.notifications.defaultPreference}`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateNotificationPreference = async (
  project: any,
  payload: any
) => {
  return patch(
    `${ApiUrl.notifications.defaultPreference}/`,
    payload,
    { project }
  );
};

export const getNotificationsList = async (project: any, params?: any) => {
  try {
    const res = await get(`${ApiUrl.notifications.list}`, {
      project,
      ...params,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const markNotificationAsRead = async (
  project: any,
  notificationId: string | number
) => {
  try {
    const res = await patch(
      `${ApiUrl.notifications.markAsRead(notificationId)}`,
      { is_read: true },
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const markNotificationAsUnread = async (
  project: any,
  notificationId: string | number
) => {
  try {
    const res = await patch(
      `${ApiUrl.notifications.markAsRead(notificationId)}`,
      { is_read: false },
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteNotification = async (
  project: any,
  notificationId: string | number
) => {
  try {
    const res = await remove(
      `${ApiUrl.notifications.delete(notificationId)}`,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const bulkNotificationActions = async (
  project: any,
  payload: {
    action: 'mark_as_read' | 'mark_as_unread' | 'delete';
    notification_ids: (string | number)[];
  }
) => {
  try {
    const res = await post(
      `${ApiUrl.notifications.bulkActions}`,
      payload,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const registerPushSubscription = async (
  project: any,
  payload: {
    fcm_token: string;
    platform: 'web' | 'mobile';
    browser_instance_id?: string;
    device_id?: string;
    user_agent?: string;
  }
) => {
  try {
    const res = await post(
      `${ApiUrl.notifications.pushSubscriptions}`,
      payload,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updatePushSubscription = async (
  project: any,
  id: number,
  updateData: {
    fcm_token?: string;
    user_agent?: string;
    is_active?: boolean;
  }
) => {
  try {
    const res = await put(
      `${ApiUrl.notifications.pushSubscriptions}${id}/`,
      updateData,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const unsubscribeFromPushNotifications = async (
  project: any,
  id: number
) => {
  try {
    const res = await remove(
      `${ApiUrl.notifications.pushSubscriptions}${id}/`,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUserPushSubscriptions = async (project: any) => {
  try {
    const res = await get(
      `${ApiUrl.notifications.pushSubscriptions}`,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
